import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnChanges {

  @Input() public show: boolean;
  @Input() public iconName = 'fa-ellipsis-v';
  @Input() public top = 20;
  @Input() public right: number;
  @Input() public bottom: number;
  @Input() public left = 10;

  @Output() public hidden = new EventEmitter<any>();
  @Output() public showed = new EventEmitter<any>();

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.top && this.top === null) {
      this.top = undefined;
    }
    if (changes.left && this.left === null) {
      this.left = undefined;
    }
    if (changes.right && this.right !== undefined) {
      if (this.right === null) { this.right = undefined; }
      this.left = undefined;
    }
    if (changes.bottom && this.bottom !== undefined) {
      if (this.bottom === null) { this.bottom = undefined; }
      this.top = undefined;
    }
  }

  public onClickOutside(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.show = false;
    this.hidden.emit();
  }

  public onShowMenu(ev: MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    this.show = !this.show;
    this.show ? this.showed.emit() : this.hidden.emit();
    if (this.show) {
      if (this.bottom === undefined && !!this.top && ev.clientY > window.innerHeight / 2) {
        this.bottom = this.top;
        this.top = undefined;
      }
      if (this.top === undefined && !!this.bottom && ev.clientY <= window.innerHeight / 2) {
        this.top = this.bottom;
        this.bottom = undefined;
      }
    }
  }

  public onClickMenu(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
  }
}
